import { FC } from "react";
import { IconPropsType } from ".";

export const Reserve: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 8C15.3333 3.94991 12.0501 0.666667 8 0.666667C3.94991 0.666667 0.666667 3.94991 0.666667 8C0.666667 12.0501 3.94991 15.3333 8 15.3333ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49074 4.43946C7.5615 2.60606 5.16322 1.76522 3.55566 1.555L4 1C5.72454 1.22552 7.90459 2.00566 9.95304 3.95235C12.0135 5.91041 13.9258 9.12619 13.6702 13.5389L13 13.5C13.2442 9.28492 11.408 6.2615 9.49074 4.43946Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.865 10.2883C13.0831 8.9249 14.6789 7.29227 15.413 6.22217L15.5 6.99994C14.7129 8.14727 13.549 9.37589 11.2576 10.7843C8.96349 12.1944 6.0165 13.3333 2.66699 13.3333L2 12.9999C5.17033 12.9999 8.64952 11.65 10.865 10.2883Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.60622 6.93749C3.60552 6.72949 1.55665 7.35565 0.285109 8.00137L0 7.39522C1.3456 6.71189 3.51687 6.04223 5.67087 6.26617C7.84767 6.49248 10.0042 7.63512 11.2356 10.5532C11.2372 10.5572 11.2388 10.5611 11.2404 10.5651C11.5272 11.3226 11.7582 12.4737 11.2796 13.5594C10.7929 14.6639 9.623 15.5908 7.3401 15.9999L7.22973 15.3351C9.39596 14.9468 10.3254 14.1042 10.6893 13.2785C11.0604 12.4366 10.8955 11.5 10.6384 10.8181C9.51394 8.15866 7.58264 7.14297 5.60622 6.93749Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1294 5.34555C12.6708 4.02312 12.508 2.69912 12.4443 1.8332L13.1171 1.77783C13.1784 2.61194 13.3343 3.86349 13.7629 5.0996C14.1919 6.33667 14.8838 7.5292 15.9999 8.28833L15.635 8.88894C14.3517 8.01604 13.5877 6.66703 13.1294 5.34555Z"
        fill={props.color}
      />
    </svg>
  );
};
